export default __webpack_public_path__ + "static/media/custom-input-file.e37ffc94.svg";